export default function isOnLine() {
  // fuck android
  if (window.zzcApp) {
    return window.zzcApp.networkIsConnection;
  } else {
    return window.navigator.onLine;
  }
};





// WEBPACK FOOTER //
// ./src/native/isOnLine.js